import styled from 'styled-components';

import { Menu } from '@style/global-style.app';

import { Title } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const ExplorerMenuWrapper = styled.div`
  padding: 48px 0 48px 48px;
  width: 366px;
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 48px;
  padding-right: 24px;
  padding-bottom: 14px;
`;

export const ExplorerMenu = styled(Menu)`
  width: 294px;

  & .ant-menu-item-group,
  & .ant-menu-submenu {
    padding: 8px 0 0 0;
  }

  & .ant-menu-item-group-title,
  & .ant-menu-submenu-title {
    padding: 0 0 4px !important;
  }

  & .ant-menu-item {
    padding: 12px 16px 12px 32px !important;
  }

  & .ant-menu-submenu-selected {
    & .ant-menu-submenu-arrow {
      color: ${ColorEnum.Teal100};
    }
  }
`;

export const ExplorerMenuGroupWrapper = styled.div`
  border-top: 1px solid ${ColorEnum.Black90};
  padding-top: 2px;
`;

export const ExplorerGroupTitle = styled(Title).attrs({
  color: ColorEnum.Black40,
  level: 6,
  mb: 0,
  weight: 400,
})`
  padding: 12px 12px;
`;

export const ExplorerMenuTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ExTitle = styled(Title).attrs({
  color: ColorEnum.Black3,
  level: 5,
  weight: 300,
  mt: 13,
})``;
